import { useState } from 'react';

const CategorySelector = ({ categories, selectedCategoryId, onCategorySelect }) => {
    const [isOpenCategory, setIsOpenCategory] = useState(false);
    
    const selectedCategory = categories.find(cat => cat.id === selectedCategoryId);

    const handleCategorySelect = (categoryId) => {
        onCategorySelect(categoryId);
        setIsOpenCategory(false);
    };

    return (
        <div className="max-w-md mx-auto p-6 bg-gradient-to-br from-gray-50 to-white rounded-3xl">
            <div className="space-y-4">
                <div className="text-center mb-6">
                    <h3 className="text-xl font-bold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent mb-1">
                        Kategori Pengeluaran
                    </h3>
                    <p className="text-gray-500 text-sm">Pilih kategori yang sesuai dengan pengeluaranmu</p>
                </div>

                {/* Custom Select Button */}
                <div className="relative">
                    <button
                        type="button"
                        onClick={() => setIsOpenCategory(!isOpenCategory)}
                        className={`w-full p-4 rounded-2xl border-2 transition-all duration-300 text-left flex items-center justify-between ${
                            selectedCategory
                                ? 'border-indigo-300 bg-gradient-to-r from-indigo-50 to-purple-50 text-gray-800'
                                : 'border-gray-200 bg-white hover:border-gray-300 hover:bg-gray-50 text-gray-500'
                        } focus:outline-none focus:ring-4 focus:ring-indigo-100 shadow-md hover:shadow-lg`}
                    >
                        <div className="flex items-center space-x-3">
                            {selectedCategory ? (
                                <>
                                    <span className="text-2xl">{selectedCategory.icon}</span>
                                    <span className="font-semibold text-gray-800">{selectedCategory.name}</span>
                                </>
                            ) : (
                                <>
                                    <span className="text-2xl">📋</span>
                                    <span>Pilih Kategori</span>
                                </>
                            )}
                        </div>

                        <svg
                            className={`w-5 h-5 transition-transform duration-300 ${isOpenCategory ? 'rotate-180' : ''}`}
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                        </svg>
                    </button>

                    {/* Dropdown Options */}
                    {isOpenCategory && (
                        <div className="absolute top-full left-0 right-0 mt-2 bg-white border border-gray-200 rounded-2xl shadow-2xl z-50 max-h-80 overflow-y-auto">
                            <div className="p-2">
                                {categories.map((category) => (
                                    <button
                                        key={category.id}
                                        onClick={() => handleCategorySelect(category.id)}
                                        className={`w-full p-3 rounded-xl text-left transition-all duration-200 flex items-center space-x-3 group ${
                                            selectedCategoryId === category.id
                                                ? `bg-gradient-to-r ${category.color} text-white shadow-lg`
                                                : 'hover:bg-gray-50 text-gray-700'
                                        }`}
                                    >
                                        <span className={`text-xl ${
                                            selectedCategoryId === category.id
                                                ? 'animate-bounce'
                                                : 'group-hover:animate-pulse'
                                        }`}>
                                            {category.icon}
                                        </span>
                                        <span className="font-medium">{category.name}</span>

                                        {selectedCategoryId === category.id && (
                                            <div className="ml-auto">
                                                <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                                </svg>
                                            </div>
                                        )}
                                    </button>
                                ))}
                            </div>
                        </div>
                    )}
                </div>

                {/* Selected Category Display */}
                {selectedCategory && (
                    <div className={`p-4 rounded-2xl bg-gradient-to-r text-black text-white text-center transform transition-all duration-300 animate-fadeIn`}>
                        <div className="flex items-center justify-center space-x-2 mb-2">
                            <span className="text-2xl animate-pulse">{selectedCategory.icon}</span>
                            <span className="font-bold">Kategori Terpilih</span>
                        </div>
                        <p className="text-white-90 text-sm">
                            Pengeluaran akan dicatat dalam kategori "{selectedCategory.name}"
                        </p>
                    </div>
                )}

                {/* Hidden select for form compatibility */}
                <select
                    name="finance_category_id"
                    value={selectedCategoryId}
                    onChange={(e) => onCategorySelect(e.target.value)}
                    className="hidden"
                    required
                >
                    <option value="">Pilih Kategori</option>
                    {categories.map(cat => (
                        <option key={cat.id} value={cat.id}>{cat.name}</option>
                    ))}
                </select>
            </div>
        </div>
    );
};

export default CategorySelector; 